import {frontend} from 'pageflow-scrolled/frontend';
import {features} from 'pageflow/frontend'
import {EarRealityPlayer} from './EarRealityPlayer.jsx';

frontend.contentElementTypes.register('earRealityPlayer', {
  component: EarRealityPlayer,
  lifecycle: true,

  consentVendors({t}) {
    const prefix = 'pageflow_scrolled.public.ear_reality';

    return [{
      name: 'earReality',
      displayName: t(`${prefix}.consent_vendor_name`),
      description: t(`${prefix}.consent_vendor_description`),
      paradigm: features.isEnabled('ear_reality_opt_in') ? 'lazy opt-in' : 'skip'
    }];
  }
});
